module.exports = __webpack_public_path__ + "static/media/logo-vida.744fc01f.svg";